import { ClipboardEvent, KeyboardEvent, useRef, useState } from "react";
import { FaTimes } from "react-icons/fa";
import { adicionarEmails, emailInvalido } from "../../utils/emailsEnvio";
import { CaixaEmails, ChipEmail, MensagemErroEmails } from "./style";

interface IProps {
  emails: string[];
  onChange: (emails: string[]) => void;
}

export function CampoEmails({ emails, onChange }: IProps) {
  const input = useRef<HTMLInputElement>(null);
  const [texto, setTexto] = useState("");
  const temInvalido = emails.some(emailInvalido);

  function confirmar(conteudo: string) {
    if (conteudo.trim()) onChange(adicionarEmails(emails, conteudo));
    setTexto("");
  }

  function aoTeclar(evento: KeyboardEvent<HTMLInputElement>) {
    if (["Enter", ",", ";"].includes(evento.key)) {
      evento.preventDefault();
      confirmar(texto);
    } else if (evento.key === "Backspace" && !texto && emails.length) {
      onChange(emails.slice(0, -1));
    }
  }

  // O input de uma linha junta as linhas coladas: uma lista colada vira chips na hora.
  function aoColar(evento: ClipboardEvent<HTMLInputElement>) {
    const colado = evento.clipboardData.getData("text");

    if (!/[\s,;]/.test(colado.trim())) return;

    evento.preventDefault();
    confirmar(`${texto} ${colado}`);
  }

  return (
    <>
      <CaixaEmails $erro={temInvalido} onClick={() => input.current?.focus()}>
        {emails.map((email) => (
          <ChipEmail key={email} $invalido={emailInvalido(email)}>
            {email}
            <FaTimes
              role="button"
              aria-label={`Remover ${email}`}
              onClick={() => onChange(emails.filter((item) => item !== email))}
            />
          </ChipEmail>
        ))}
        <input
          ref={input}
          aria-label="E-mail"
          value={texto}
          placeholder={emails.length ? "" : "Digite o e-mail e tecle ENTER"}
          onChange={(evento) => setTexto(evento.target.value)}
          onKeyDown={aoTeclar}
          onPaste={aoColar}
          onBlur={() => confirmar(texto)}
        />
      </CaixaEmails>
      {temInvalido && (
        <MensagemErroEmails>
          Remova os e-mails inválidos para enviar.
        </MensagemErroEmails>
      )}
    </>
  );
}
